import { Dispatch, CSSProperties } from "react";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import { Button, Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { StateAction } from "./state/actions/actions";
import { StateInterface } from "./state/reducer/store";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import GraphicEqIcon from "@material-ui/icons/GraphicEq";
import { FC } from "react";
import { theme } from "../assets/theme";
import walking from '../assets/walking.svg';
import "aos/dist/aos.css"
import PremiumVoiceDemo from "./PremiumVoiceDemo";
import { AccountCircle } from "@material-ui/icons";

const headerButtonStyle: CSSProperties = {
  color: "white",
  borderRadius: 25,
  padding: 24,
  height: 32,
};
interface HeaderInterface {
  scrollToRef: (refName: string) => void
}

const Header: FC<HeaderInterface> = ({ scrollToRef }) => {
  const currentUser = useSelector((state: StateInterface) => state.user);
  const config = useSelector((state: StateInterface) => state.config);
  const dispatch: Dispatch<StateAction> = useDispatch();

  return (
    <>
      {/* <Box style={{ display: 'flex', alignItems: 'center', position: 'absolute', left: 10, top: -5 }}>
      <img src={logo} alt="Audio Anything" style={{ height: 50, width: 50, zIndex: 10000 }} />
      <h3 style={{ fontSize: 24, color: 'white', marginLeft: 8, width: 300, zIndex: 10000 }}> Audio Anything</h3>

    </Box> */}
      <AppBar
        position="static"
        color="default"
        style={{
          height: "auto",
          display: "flex",
          alignItems: "center",
          backgroundColor: theme.palette.primary.light
          // backgroundImage:
          // "radial-gradient( circle farthest-corner at 12.3% 19.3%,  rgba(85,88,218,1) 0%, rgba(95,209,249,1) 100.2% )",
          // background: "linear-gradient(to right, #ad5389, #3c1053)",
        }}
      >

        <Grid
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            paddingTop: 16,
            width: '90vw'
          }}
          container
        >
          {/* 
        <Button onClick={() => {
          scrollToRef('availableVoicesRef')
        }} style={{ ...headerButtonStyle, width: 200 }}>
          Available Voices <RecordVoiceOverIcon style={{ marginLeft: 8 }} />
        </Button> */}

          <Button
            style={{ ...headerButtonStyle }}
            onClick={() => scrollToRef('audioGeneratorRef')}
          >
            {config.textByLanguage["header.audioGenerator"]} <GraphicEqIcon style={{ marginLeft: 8 }} />
          </Button>
          <Button color="secondary" style={{ ...headerButtonStyle }} onClick={() => scrollToRef('pricingRef')}>
            {config.textByLanguage["header.pricing"]} <AttachMoneyIcon style={{ marginLeft: 8 }} />
          </Button>
          <Button color="secondary" style={{ ...headerButtonStyle }} onClick={() => scrollToRef('faqRef')}>
            {config.textByLanguage["header.faq"]} <LiveHelpIcon style={{ marginLeft: 8 }} />
          </Button>
          <Button
            variant="contained"
            style={{backgroundColor:theme.palette.primary.main, color:theme.palette.common.white}}
            onClick={() => dispatch({ type: "SET_LOGIN_MODAL", payload: true })}
          >
            {currentUser ? currentUser.displayName : config.textByLanguage["header.login"]}
            <AccountCircle style={{ marginLeft: 16, fontSize: 32 }} />
          </Button>
        </Grid>

        <Grid container style={{ margin: "60px 32px 32px 32px", display: "flex" }}>
          <Grid item md={6}>
            <Typography
              variant="h3"
              style={{
                color: "white",
                fontWeight: "bold",
                marginLeft: "4rem",
              }}
            >
              {config.textByLanguage["header.title"]}
            </Typography>

            <Typography
              variant="h5"
              style={{
                color: "white",
                marginLeft: "4rem",
                marginBottom: 16,
                marginTop: 16,
              }}
            >
              {config.textByLanguage["header.summary"]}
            </Typography>
            {/* <Description /> */}
            <PremiumVoiceDemo />
          </Grid>




          <Grid item md={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

            <img src={walking} alt="Person Walking" style={{ backgroundColor: theme.palette.primary.light, width: '60%' }} />

          </Grid>


        </Grid>
      </AppBar>
    </>

  );
};

export default Header;
